// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_SetInt = require("rescript/lib/js/belt_SetInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("../worker/MM_wrk_client.bs.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var MM_wrk_FindParens = require("../worker/MM_wrk_FindParens.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Expln_utils_common = require("@expln/utils/src/main/Expln_utils_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_asrts_to_skip = require("./MM_cmp_asrts_to_skip.bs.js");
var MM_cmp_type_settings = require("./MM_cmp_type_settings.bs.js");
var Divider = require("@mui/material/Divider").default;
var Expln_utils_jsonParse = require("@expln/utils/src/main/Expln_utils_jsonParse.bs.js");
var TextField = require("@mui/material/TextField").default;
var Sync = require("@mui/icons-material/Sync").default;
var IconButton = require("@mui/material/IconButton").default;

var allColors = [
  "#e6194B",
  "#3cb44b",
  "#ffe119",
  "#4363d8",
  "#f58231",
  "#911eb4",
  "#42d4f4",
  "#f032e6",
  "#bfef45",
  "#fabed4",
  "#469990",
  "#dcbeff",
  "#9A6324",
  "#fffac8",
  "#800000",
  "#aaffc3",
  "#808000",
  "#ffd8b1",
  "#000075",
  "#a9a9a9",
  "#000000"
];

var asrtsToSkipRegexDefault = "New usage of \"([^\"]+)\" is discouraged";

function createDefaultSettings(param) {
  return {
          nextId: 4,
          parens: "( ) [ ] { }",
          parensErr: undefined,
          typeSettings: [
            {
              id: "0",
              typ: "wff",
              color: "#4363d8",
              prefix: "&W",
              err: undefined
            },
            {
              id: "1",
              typ: "term",
              color: "#000000",
              prefix: "&T",
              err: undefined
            },
            {
              id: "2",
              typ: "setvar",
              color: "#e6194B",
              prefix: "&S",
              err: undefined
            },
            {
              id: "3",
              typ: "class",
              color: "#f032e6",
              prefix: "&C",
              err: undefined
            }
          ],
          asrtsToSkip: [],
          asrtsToSkipRegex: asrtsToSkipRegexDefault
        };
}

var strContainsWhitespaceRegex = /\s+/;

function validateAndCorrectTypeSetting(ts) {
  var newTyp = ts.typ.trim();
  var typHasWhitespace = Belt_Option.isSome(Caml_option.null_to_opt(newTyp.match(strContainsWhitespaceRegex)));
  var typIsEmpty = newTyp.length === 0;
  var newColor = allColors.includes(ts.color) ? ts.color : Caml_array.get(allColors, 0);
  var newPrefix = ts.prefix.trim();
  var prefixHasWhitespace = Belt_Option.isSome(Caml_option.null_to_opt(newPrefix.match(strContainsWhitespaceRegex)));
  var prefixIsEmpty = newPrefix.length === 0;
  var err = typHasWhitespace ? "Type should not contain whitespaces." : (
      typIsEmpty ? "Type should not be empty." : (
          prefixHasWhitespace ? "Work variable prefix should not contain whitespaces." : (
              prefixIsEmpty ? "Work variable prefix should not be empty." : undefined
            )
        )
    );
  return {
          id: ts.id,
          typ: newTyp,
          color: newColor,
          prefix: newPrefix,
          err: err
        };
}

function validateAndCorrectState(st) {
  var validatedTypeSettings = st.typeSettings.map(validateAndCorrectTypeSetting);
  var distinctIds = Belt_SetInt.fromArray(validatedTypeSettings.map(function (ts) {
            return Belt_Option.getWithDefault(Belt_Int.fromString(ts.id), 0);
          }));
  var validatedTypeSettings$1;
  if (Belt_SetInt.size(distinctIds) !== validatedTypeSettings.length) {
    var maxId = Belt_Option.getWithDefault(Belt_SetInt.maximum(distinctIds), 0);
    validatedTypeSettings$1 = validatedTypeSettings.map(function (ts, i) {
          return {
                  id: String((maxId + i | 0) + 1 | 0),
                  typ: ts.typ,
                  color: ts.color,
                  prefix: ts.prefix,
                  err: ts.err
                };
        });
  } else {
    validatedTypeSettings$1 = validatedTypeSettings;
  }
  var maxTypSettId = validatedTypeSettings$1.reduce((function (maxId, ts) {
          var id = Belt_Int.fromString(ts.id);
          var id$1;
          if (id !== undefined) {
            id$1 = id;
          } else {
            throw {
                  RE_EXN_ID: MM_parser.MmException,
                  _1: {
                    msg: "Cannot convert string to int for typeSettingsState.id"
                  },
                  Error: new Error()
                };
          }
          if (id$1 <= maxId) {
            return maxId;
          } else {
            return id$1;
          }
        }), 0);
  var newNextId = maxTypSettId < st.nextId ? st.nextId : maxTypSettId + 1 | 0;
  var newParens = st.parens.trim();
  var parensErr = Common.getSpaceSeparatedValuesAsArray(newParens).length % 2 === 0 ? undefined : "Number of parentheses must be even.";
  return {
          nextId: newNextId,
          parens: newParens,
          parensErr: parensErr,
          typeSettings: validatedTypeSettings$1,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex
        };
}

function stateToSettings(st) {
  return {
          parens: st.parens,
          typeSettings: st.typeSettings.map(function (typSett) {
                return {
                        typ: typSett.typ,
                        color: typSett.color,
                        prefix: typSett.prefix
                      };
              }),
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex
        };
}

var settingsLocStorKey = "settings";

function saveStateToLocStor(st) {
  localStorage.setItem(settingsLocStorKey, Expln_utils_common.stringify(stateToSettings(st)));
}

function readStateFromLocStor(param) {
  var defaultSettings = createDefaultSettings(undefined);
  var settingsLocStorStr = localStorage.getItem(settingsLocStorKey);
  if (settingsLocStorStr === null) {
    return defaultSettings;
  }
  var parseResult = Expln_utils_jsonParse.parseJson(settingsLocStorStr, (function (__x) {
          return Expln_utils_jsonParse.asObj(__x, (function (d) {
                        return {
                                nextId: 0,
                                parens: Expln_utils_jsonParse.str(d, "parens", undefined, (function (param) {
                                        return defaultSettings.parens;
                                      }), undefined),
                                parensErr: undefined,
                                typeSettings: Expln_utils_jsonParse.arr(d, "typeSettings", (function (__x) {
                                        return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                      return {
                                                              id: "0",
                                                              typ: Expln_utils_jsonParse.str(d, "typ", undefined, undefined, undefined),
                                                              color: Expln_utils_jsonParse.str(d, "color", undefined, undefined, undefined),
                                                              prefix: Expln_utils_jsonParse.str(d, "prefix", undefined, undefined, undefined),
                                                              err: undefined
                                                            };
                                                    }), undefined, undefined, undefined);
                                      }), undefined, (function (param) {
                                        return defaultSettings.typeSettings;
                                      }), undefined),
                                asrtsToSkip: Expln_utils_jsonParse.arr(d, "asrtsToSkip", (function (__x) {
                                        return Expln_utils_jsonParse.asStr(__x, undefined, undefined, undefined);
                                      }), undefined, (function (param) {
                                        return [];
                                      }), undefined),
                                asrtsToSkipRegex: Expln_utils_jsonParse.str(d, "asrtsToSkipRegex", undefined, (function (param) {
                                        return asrtsToSkipRegexDefault;
                                      }), undefined)
                              };
                      }), undefined, undefined, undefined);
        }), undefined, (function (param) {
          return defaultSettings;
        }), undefined);
  if (parseResult.TAG === /* Ok */0) {
    return validateAndCorrectState(parseResult._0);
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot read settings from the local storage: " + parseResult._0 + ""
        },
        Error: new Error()
      };
}

function settingsReadFromLocStor(param) {
  return stateToSettings(readStateFromLocStor(undefined));
}

function isValid(st) {
  if (Belt_Option.isNone(st.parensErr)) {
    return st.typeSettings.every(function (ts) {
                return Belt_Option.isNone(ts.err);
              });
  } else {
    return false;
  }
}

function eqState(st1, st2) {
  if (st1.parens === st2.parens && Caml_obj.equal(st1.asrtsToSkip, st2.asrtsToSkip) && st1.asrtsToSkipRegex === st2.asrtsToSkipRegex && st1.typeSettings.length === st2.typeSettings.length) {
    return st1.typeSettings.every(function (ts1, i) {
                var ts2 = Caml_array.get(st2.typeSettings, i);
                if (ts1.typ === ts2.typ && ts1.color === ts2.color) {
                  return ts1.prefix === ts2.prefix;
                } else {
                  return false;
                }
              });
  } else {
    return false;
  }
}

function updateParens(st, parens) {
  return {
          nextId: st.nextId,
          parens: parens,
          parensErr: undefined,
          typeSettings: st.typeSettings,
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex
        };
}

function updateTypeSetting(st, id, update) {
  return {
          nextId: st.nextId,
          parens: st.parens,
          parensErr: st.parensErr,
          typeSettings: st.typeSettings.map(function (ts) {
                if (ts.id === id) {
                  return Curry._1(update, ts);
                } else {
                  return ts;
                }
              }),
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex
        };
}

function addTypeSetting(st) {
  var newId = String(st.nextId);
  return {
          nextId: st.nextId + 1 | 0,
          parens: st.parens,
          parensErr: st.parensErr,
          typeSettings: st.typeSettings.concat([{
                  id: newId,
                  typ: "",
                  color: Caml_array.get(allColors, 0),
                  prefix: "",
                  err: undefined
                }]),
          asrtsToSkip: st.asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex
        };
}

function setAsrtsToSkip(st, asrtsToSkip) {
  return {
          nextId: st.nextId,
          parens: st.parens,
          parensErr: st.parensErr,
          typeSettings: st.typeSettings,
          asrtsToSkip: asrtsToSkip,
          asrtsToSkipRegex: st.asrtsToSkipRegex
        };
}

function MM_cmp_settings(Props) {
  var modalRef = Props.modalRef;
  var ctx = Props.ctx;
  var initialSettings = Props.initialSettings;
  var onChange = Props.onChange;
  var match = React.useState(function () {
        return validateAndCorrectState({
                    nextId: 0,
                    parens: initialSettings.parens,
                    parensErr: undefined,
                    typeSettings: initialSettings.typeSettings.map(function (lts) {
                          return {
                                  id: "0",
                                  typ: lts.typ,
                                  color: lts.color,
                                  prefix: lts.prefix,
                                  err: undefined
                                };
                        }),
                    asrtsToSkip: initialSettings.asrtsToSkip,
                    asrtsToSkipRegex: initialSettings.asrtsToSkipRegex
                  });
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return state;
      });
  var setPrevState = match$1[1];
  var prevState = match$1[0];
  var actParensChange = function (parens) {
    Curry._1(setState, (function (__x) {
            return updateParens(__x, parens);
          }));
  };
  var actTypeSettingAdd = function (param) {
    Curry._1(setState, addTypeSetting);
  };
  var actTypeSettingDelete = function (id) {
    Curry._1(setState, (function (__x) {
            return {
                    nextId: __x.nextId,
                    parens: __x.parens,
                    parensErr: __x.parensErr,
                    typeSettings: __x.typeSettings.filter(function (ts) {
                          return ts.id !== id;
                        }),
                    asrtsToSkip: __x.asrtsToSkip,
                    asrtsToSkipRegex: __x.asrtsToSkipRegex
                  };
          }));
  };
  var actTypeChange = function (id, typ) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: typ,
                                  color: ts.color,
                                  prefix: ts.prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actColorChange = function (id, color) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: ts.typ,
                                  color: color,
                                  prefix: ts.prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var actPrefixChange = function (id, prefix) {
    Curry._1(setState, (function (__x) {
            return updateTypeSetting(__x, id, (function (ts) {
                          return {
                                  id: ts.id,
                                  typ: ts.typ,
                                  color: ts.color,
                                  prefix: prefix,
                                  err: undefined
                                };
                        }));
          }));
  };
  var makeActTerminate = function (modalId) {
    return Belt_Option.map(modalId, (function (modalId, param) {
                  MM_wrk_client.terminateWorker(undefined);
                  Expln_React_Modal.closeModal(modalRef, modalId);
                }));
  };
  var rndFindParensProgress = function (pct, modalIdOpt) {
    return MM_react_common.rndProgress("Searching parentheses", pct, makeActTerminate(modalIdOpt), undefined);
  };
  var rndAsrtsToSkip = function (param) {
    var asrtsSelected = String(state.asrtsToSkip.length);
    return React.createElement(Expln_React_Row.make, {
                style: {
                  marginTop: "5px",
                  marginBottom: "5px"
                },
                children: null
              }, React.createElement("span", undefined, "Assertions to skip: " + asrtsSelected + " assertions selected."), React.createElement("span", {
                    style: {
                      color: "blue",
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                    return null;
                                  })), (function (modalId) {
                                Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                        return React.createElement(Paper, {
                                                    style: {
                                                      padding: "10px"
                                                    },
                                                    children: React.createElement(MM_cmp_asrts_to_skip.make, {
                                                          initText: state.asrtsToSkip.join("\n"),
                                                          initRegex: state.asrtsToSkipRegex,
                                                          onSave: (function (res) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              Curry._1(setState, (function (st) {
                                                                      var st$1 = setAsrtsToSkip(st, res.asrtsToSkip);
                                                                      var asrtsToSkipRegex = res.regex;
                                                                      return {
                                                                              nextId: st$1.nextId,
                                                                              parens: st$1.parens,
                                                                              parensErr: st$1.parensErr,
                                                                              typeSettings: st$1.typeSettings,
                                                                              asrtsToSkip: st$1.asrtsToSkip,
                                                                              asrtsToSkipRegex: asrtsToSkipRegex
                                                                            };
                                                                    }));
                                                            }),
                                                          onCancel: (function (param) {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        })
                                                  });
                                      }));
                              }));
                      })
                  }, "edit"));
  };
  var msg = state.parensErr;
  return React.createElement(Expln_React_Column.make, {
              spacing: 1,
              style: {
                margin: "30px"
              },
              children: null
            }, React.createElement(Expln_React_Row.make, {
                  alignItems: "center",
                  children: null
                }, React.createElement(TextField, {
                      value: state.parens,
                      label: "Parentheses",
                      size: "small",
                      style: {
                        width: "400px"
                      },
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actParensChange, param);
                        }),
                      title: "Parentheses are used to speed up finding of substitutions",
                      error: Belt_Option.isSome(state.parensErr)
                    }), React.createElement("span", {
                      title: "Determine parentheses from the loaded MM file"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return rndFindParensProgress(0, undefined);
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                              return rndFindParensProgress(0, Caml_option.some(modalId));
                                            }));
                                      MM_wrk_FindParens.beginFindParens(ctx, (function (pct) {
                                              Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                      return rndFindParensProgress(pct, Caml_option.some(modalId));
                                                    }));
                                            }), (function (parens) {
                                              Curry._1(setState, (function (__x) {
                                                      return updateParens(__x, parens);
                                                    }));
                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                            }));
                                    }));
                            }),
                          children: React.createElement(Sync, {})
                        }))), rndAsrtsToSkip(undefined), msg !== undefined ? React.createElement("pre", {
                    style: {
                      color: "red"
                    }
                  }, msg) : null, React.createElement(Divider, {}), React.createElement(MM_cmp_type_settings.make, {
                  typeSettings: state.typeSettings,
                  availableColors: allColors,
                  onAdd: actTypeSettingAdd,
                  onTypeChange: actTypeChange,
                  onColorChange: actColorChange,
                  onPrefixChange: actPrefixChange,
                  onDelete: actTypeSettingDelete
                }), React.createElement(Divider, {}), eqState(prevState, state) ? null : React.createElement(Expln_React_Row.make, {
                    spacing: 3,
                    children: null
                  }, React.createElement(Button, {
                        onClick: (function (param) {
                            var st = validateAndCorrectState(state);
                            Curry._1(setState, (function (param) {
                                    return st;
                                  }));
                            if (isValid(st)) {
                              saveStateToLocStor(st);
                              Curry._1(setPrevState, (function (param) {
                                      return st;
                                    }));
                              return Curry._1(onChange, stateToSettings(st));
                            }
                            
                          }),
                        variant: "contained",
                        disabled: !isValid(state),
                        children: "Apply changes"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(setState, (function (param) {
                                    return prevState;
                                  }));
                          }),
                        children: "Discard changes"
                      })));
}

var make = MM_cmp_settings;

exports.settingsReadFromLocStor = settingsReadFromLocStor;
exports.make = make;
/* react Not a pure module */
